import { useTranslation } from "react-i18next";

const TermPaymentDetails = ({ termPayment, hideHeading }) => {
  const { purchaseOrderNumber, paymentMethod } = termPayment;
  const { t } = useTranslation();

  return (
    <>
      {!hideHeading && <h6 className="h6 fw-bold term-payment-title">{t("frontend.checkout.payment_method")}</h6>}
      <p className="mb-1">
        <em>{paymentMethod.paymentMethodName}</em>
        <br />
        {purchaseOrderNumber}
      </p>
    </>
  );
};
export { TermPaymentDetails };
